import { createSelector } from 'reselect';
import { RootState } from 'typesafe-actions';
import { SeoState } from './reducer';

export const getSeo = (state: RootState) => state.seo;
export const getSEOData = createSelector(getSeo, (state: SeoState) => state.data);
